import type { MovementRow } from '@contracts';

/**
 * Historial de movimientos de stock (pantalla 2 del inventario de Odoo).
 * Feed: fecha · producto · tipo (venta/compra/transfer/ajuste) · Desde → A · unidades.
 */
export function MovementsTableWidget({ data }: { data: MovementRow[] }) {
  const rows = Array.isArray(data) ? data : [];
  if (!rows.length) {
    return <div className="grid h-full place-items-center text-sm text-slate-400">Sin movimientos</div>;
  }

  // Color del chip de tipo de movimiento.
  const chip = (t: string) => {
    if (t === 'Venta') return 'bg-emerald-100 text-emerald-700';
    if (t === 'Compra') return 'bg-blue-100 text-blue-700';
    if (t === 'Transferencia') return 'bg-amber-100 text-amber-700';
    if (t === 'Ajuste') return 'bg-violet-100 text-violet-700';
    return 'bg-slate-100 text-slate-600';
  };

  return (
    <div className="h-full overflow-auto pr-1">
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-white">
          <tr className="text-[10px] font-bold uppercase tracking-wide text-slate-400">
            <th className="py-1 text-left">Fecha</th>
            <th className="py-1 text-left">Tipo</th>
            <th className="py-1 text-left">Producto</th>
            <th className="py-1 text-left">Cliente / Prov.</th>
            <th className="py-1 text-left">Desde → A</th>
            <th className="py-1 text-right">Unid.</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id ?? i} className="border-b border-slate-50 last:border-0 hover:bg-slate-50/60">
              <td className="py-1.5 whitespace-nowrap text-slate-500">{r.date}</td>
              <td className="py-1.5">
                <span className={`rounded px-1.5 py-0.5 text-[10px] font-semibold ${chip(r.type)}`}>{r.type}</span>
              </td>
              <td className="py-1.5">
                <span className="truncate text-slate-700">{r.name}</span>
                {r.category && <span className="block text-[10px] text-slate-400">{r.category}</span>}
              </td>
              <td className="py-1.5 truncate text-slate-500">{r.partner || '—'}</td>
              <td className="py-1.5 text-[11px] text-slate-500">
                {r.from} <span className="text-slate-300">→</span> {r.to}
              </td>
              <td className="py-1.5 text-right tabular-nums font-semibold text-slate-700">{Math.round(r.units)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
